export const STATUSES = ["Nuova", "In lavorazione", "In attesa cliente", "In attesa reparto", "Completata", "Chiusa", "Richiesta ricevuta", "Documenti necessari", "In verifica"];
export const ASSIGNEES = ["Back Office", "Reparto Credito", "Reparto Assicurazioni", "Admin"];

export const STATUS_COLORS = {
  "Nuova": "bg-blue-100 text-blue-700",
  "In lavorazione": "bg-amber-100 text-amber-700",
  "In attesa cliente": "bg-orange-100 text-orange-700",
  "In attesa reparto": "bg-purple-100 text-purple-700",
  "Completata": "bg-emerald-100 text-emerald-700",
  "Chiusa": "bg-slate-200 text-slate-600",
  "Richiesta ricevuta": "bg-blue-100 text-blue-700",
  "Documenti necessari": "bg-orange-100 text-orange-700",
  "In verifica": "bg-amber-100 text-amber-700",
};

export const TYPE_LABELS = { utenze: "Utenze", credito: "Credito", assicurazioni: "Assicurazioni" };
export const TYPE_COLORS = { utenze: "#10B981", credito: "#0A192F", assicurazioni: "#F97316" };

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric" }) : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
